import { Paper, TextField } from '@material-ui/core';
import React from 'react';

import { createReseller, IReseller, updateReseller } from '~/src/dash/api/console-api';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { Panel, Panels } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import { extractRouteParams, navigate, RouteResellerManagerList } from '~/src/dash/router/routes';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { publicaColors } from '~/src/dash/utils/colors';
import { decorate } from '~/src/dash/utils/decorator';
import { routeName } from '~/src/dash/utils/routes';
import { ButtonView } from '~/src/dash/views/button-view';
import { H1 } from '~/src/dash/views/component-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  reseller: IReseller;
}

interface IState extends IBaseState, IReseller {
  count: number;
  saving: boolean;
  snackbarMessage: string;
  snackbarError: boolean;
}

function isExistingReseller(reseller: IReseller) {
  return !!reseller.ID;
}

export const ResellerManagerView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 4,
      },
      button: {
        margin: theme.spacing.unit,
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = Object.assign(this.props.reseller, {
      count: 0,
      saving: false,
      snackbarMessage: '',
      snackbarError: false,
    });

    constructor(props: IProps) {
      super(props);
    }

    _saveReseller = (count: number) => {
      if (count !== this.state.count) {
        return;
      }
      (isExistingReseller(this.state) ? updateReseller : createReseller)({
        query: {
          reseller: this.state,
        },
      }).then(
        (reseller: IReseller) => {
          this.setState(
            Object.assign(this.state, reseller, {
              saving: false,
              snackbarMessage: 'Successfully saved reseller',
              snackbarError: false,
            }),
          );
        },
        () => {
          this.setState({
            saving: false,
            snackbarMessage: 'Saving reseller failed',
            snackbarError: true,
          });
        },
      );
    };

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({
        [target.name]: target.value,
      });
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    saveReseller = () => {
      const count = this.state.count + 1;
      this.setState(
        {
          saving: true,
          count,
        },
        () => {
          this._saveReseller(count);
        },
      );
    };

    gotoResellerListView = () => {
      navigate(
        RouteResellerManagerList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    };

    render() {
      const { classes, user, session, location } = this.props;
      const { pathname } = location;

      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel
            largeHorizontalPadding
            verticalPadding
            style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
          >
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel scroll largePadding>
            {isExistingReseller(this.state) ? (
              <H1>
                <span>Reseller: {this.state.Name} </span>
              </H1>
            ) : (
              <H1>Reseller: New</H1>
            )}
            <Paper
              classes={{
                root: classes.paper,
              }}
            >
              <div className={classes.section}>
                <TextField
                  label='Name'
                  name='Name'
                  fullWidth
                  value={this.state.Name}
                  onChange={this.handleChange}
                />
              </div>
              <div className={classes.section}>
                <TextField
                  label='LogoURL'
                  name='LogoURL'
                  fullWidth
                  value={this.state.LogoURL}
                  onChange={this.handleChange}
                />
              </div>
              <div className={classes.section}>
                <ButtonView
                  onClick={this.saveReseller}
                  text='Save'
                  active={this.state.saving}
                  disabled={this.state.saving}
                />
                <ModelSecondaryButton onClick={this.gotoResellerListView}>
                  Close
                </ModelSecondaryButton>
              </div>
            </Paper>
            <SnackbarView
              open={!!this.state.snackbarMessage}
              error={!!this.state.snackbarError}
              onClose={this.snackbarClose}
            >
              {this.state.snackbarMessage}
            </SnackbarView>
          </Panel>
        </Panels>
      );
    }
  },
);
